import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import MessageUtils from '../../util/MessageUtils'
import FormUI from './FormUI.js'

class FormSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMessageList: [],
    }
  }

  render() {
    return (
      <FormUI
        context={this.props.context}
        className={this.props.className}
        inlineButton={this.props.inlineButton}
        // text
        buttonLabel={this.props.buttonLabel}
        cancelLabel={this.props.cancelLabel}
        messageList={this.props.messageList}
        buttonMessageKey={this.props.buttonMessageKey}
        cancelMessageKey={this.props.cancelMessageKey}
        successMsg={this.props.successMsg}
        errorList={this.props.errorList}
        errorCode={this.props.errorCode}
        errorMessageList={this.state.errorMessageList}
        // state
        busy={this.props.busy}
        disabled={this.props.disabled}
        // event handlers
        onSubmit={this.onSubmit}
        onCancel={this.props.onCancel}
        // fields
        children={this.props.children}
      />
    )
  }

  UNSAFE_componentWillMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onSubmit = (event) => {
    event.preventDefault()

    let errorList = []

    React.Children.forEach(this.props.children, child => {
      if (!child) {
        // in case the element is a conditional element, child is null
        // for example:
        // {
        //   visibility === 'all' &&
        //   ...
        // }
        // if condition is false then null child is returned
        return;
      }
      let error = null
      let props = child.props
      switch (child.props.type) {
        case 'text':
        case 'code':
        case 'select':
        case 'password':
        case 'alphanumeric':
          error = this.checkInputError(props, errorList)
          props.setError(error)
          break;
        case 'name':
          error = this.checkInputError({
            type: 'text', name: props.name, label: 'First name', labelKey: 'c_first_name',
            value: props.firstName, required: props.required
          }, errorList)
          props.setFirstNameError(error)
          error = this.checkInputError({
            type: 'text', name: props.name, label: 'Last name', labelKey: 'c_last_name',
            value: props.lastName, required: props.required
          }, errorList)
          props.setLastNameError(error)
          break;
        default:
      }
    })

    if (errorList.length)
      this.props.setErrorList(errorList)

    if (errorList.length === 0)
      this.props.onSubmit(event)
  }

  checkInputError = ({type, name, label, labelKey, value, required, error, onChange, setError}, errorList) => {
    console.log(type, name, label, labelKey, value, required, error /*, onChange, setError*/)

    error = null

    // check required fields
    switch (type) {
      case 'text':
      case 'password':
      case 'select':
        if (required && !value) {
          let labelMessage = MessageUtils.getMessageValue(this.props.messageList, labelKey)
          if (!labelMessage) labelMessage = label
          let errorMessage = MessageUtils.getMessageValue(this.state.errorMessageList, 'c_required_field', [labelMessage])

          errorList.push(errorMessage)
          error = errorMessage
        }
        break;
      default:
    }

    return error
  }

  getMessages(context) {
    let elements = [
      'c_required_field',
      'c_activate_sub',
      'c_upgrade_plan'
    ]
    let keys = elements.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('w_form', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({errorMessageList : response.messageList})
  }
}

export default FormSF
